import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';

const BannerPromotion = ({ items }) => {
  const [count, setCount] = useState(1);
  const [elemActive, setElemActive] = useState('banner-1');

  const handleTab = (e) => {
    e.preventDefault();
    const elem = e.target;
    const bannerSelected = elem.dataset.banner;
    setElemActive(bannerSelected);
  };

  useEffect(() => {
    const intervalID = setInterval(() => {
      if (count <= items.length) {
        setElemActive(`banner-${count}`);
        if (count === items.length) {
          setCount(1);
        } else {
          setCount(count + 1);
        }
      } else {
        setElemActive('banner-1');
        setCount(1);
      }
    }, 6000);
    return () => clearInterval(intervalID);
  }, [count]);

  return (
    <Container fluid className="bg-white banner-cp py-60">
      <Container>
        {
          items.map((banner, ind) => {
            return (
              <Row
                className={`bg-tangaroa ${elemActive === `banner-${ind + 1}` ? `banner-${ind + 1}` : 'd-none'}`}
                key={banner.id}>
                <Col lg={3} className="bg-tangaroa order-lg-1 order-2 banner-info">
                  <div>
                    <h2 className="text-white py-15">
                      {banner.title}
                    </h2>
                    <p className="text-white pb-15">
                      {banner.description}
                    </p>
                    <a href={banner.buttonLink} target="_blank" rel="noreferrer" className="btn btn-outline btn-outline-transparent">{banner.buttonText}</a>
                  </div>
                </Col>
                <Col lg={9} className="p-0 order-lg-2 order-1 banner-content">
                  <div className="overlap-image" />
                  <img
                    src={banner.imageLink}
                    alt="banner-01"
                    height="100%"
                    width="100%" />
                  <div className="indicators row p-15 w-100">
                    {
                      items.map((s, index) => {
                        return (
                          <Col xs={3} lg={3} key={s.id}>
                            <a
                              href="/"
                              className={`not-link link link-banner-${index + 1}`}
                              onClick={handleTab}
                              data-banner={`banner-${index + 1}`}>
                              <h4>{`0${index + 1}`}</h4>
                              <hr className="line" />
                              <h4 className="d-none d-lg-block">{s.title}</h4>
                            </a>
                          </Col>
                        );
                      })
                    }
                  </div>
                </Col>
              </Row>
            );
          })
        }
      </Container>
    </Container>
  );
};

BannerPromotion.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    active: PropTypes.bool.isRequired,
    succession: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    buttonLink: PropTypes.string.isRequired,
    imageLink: PropTypes.string.isRequired,
  })).isRequired,
};

export default BannerPromotion;
